import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        VDialog,
        {
          attrs: {
            persistent: _vm.dialogProps.dialogAceitar,
            "max-width": "600px",
          },
          model: {
            value: _vm.dialogProps.visibilidade,
            callback: function ($$v) {
              _vm.$set(_vm.dialogProps, "visibilidade", $$v)
            },
            expression: "dialogProps.visibilidade",
          },
        },
        [
          _c(
            VCard,
            { staticClass: "pa-5" },
            [
              _c(
                VCardTitle,
                [
                  _c(
                    VRow,
                    { staticClass: "d-flex flex-column text-lg-center" },
                    [
                      _c(
                        "h4",
                        {
                          staticClass:
                            "headline primary--text text-no-wrap pb-8",
                        },
                        [_vm._v(" Termo de Responsabilidade ")]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                VCardText,
                [
                  _c("p", { staticClass: "text-justify" }, [
                    _vm._v(
                      " Declaro, para os devidos fins, a legitimidade das informações que serão prestadas e me comprometo a apresentar os certificados, diplomas e declarações comprovantes de sua veracidade em todas as ocasiões em que for solicitado. "
                    ),
                  ]),
                  _c(VCheckbox, {
                    staticClass: "text-justify",
                    attrs: {
                      label: _vm.termoCiencia,
                      color: "secondary",
                      readonly:
                        _vm.usuario.perfil.aceitouTermoResponsabilidade &&
                        _vm.dialogProps.dialogVisualizar,
                    },
                    model: {
                      value: _vm.usuario.perfil.aceitouTermoResponsabilidade,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.usuario.perfil,
                          "aceitouTermoResponsabilidade",
                          $$v
                        )
                      },
                      expression: "usuario.perfil.aceitouTermoResponsabilidade",
                    },
                  }),
                  _c(VCheckbox, {
                    staticClass: "text-justify",
                    attrs: {
                      color: "secondary",
                      readonly:
                        _vm.usuario.perfil.aceitouTermoUsoLgpd &&
                        _vm.dialogProps.dialogVisualizar,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c(
                              "p",
                              { staticClass: "mt-4" },
                              [
                                _vm._v(" Declaro que li e concordo com o "),
                                _c(
                                  VTooltip,
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "activator",
                                        fn: function ({ on: onTooltip }) {
                                          return [
                                            _c(
                                              "a",
                                              _vm._g(
                                                {
                                                  staticClass:
                                                    "secondary--text font-weight-regular",
                                                  attrs: {
                                                    href: "#",
                                                    "aria-label":
                                                      "acesse o termo de uso de dados do desenvolva",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.abrirTermoUso.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                },
                                                { ...onTooltip }
                                              ),
                                              [
                                                _vm._v(
                                                  " termo de uso de dados do sistema. "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "Clique visualizar o termo de uso de dados"
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.usuario.perfil.aceitouTermoUsoLgpd,
                      callback: function ($$v) {
                        _vm.$set(_vm.usuario.perfil, "aceitouTermoUsoLgpd", $$v)
                      },
                      expression: "usuario.perfil.aceitouTermoUsoLgpd",
                    },
                  }),
                  _vm.dialogProps.dialogVisualizar
                    ? _c(
                        "p",
                        { staticClass: "text-end primary--text body-2" },
                        [
                          _vm._v(
                            " Ciência dada em " +
                              _vm._s(
                                _vm._f("date")(
                                  _vm.usuario.perfil
                                    .dataAceitouTermoResponsabilidade
                                )
                              ) +
                              ". "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                VCardActions,
                [
                  _c(
                    VRow,
                    { staticClass: "justify-end ma-1" },
                    [
                      _vm.dialogProps.dialogAceitar
                        ? _c(
                            VBtn,
                            {
                              staticClass: "mr-2",
                              attrs: {
                                disabled:
                                  !_vm.usuario.perfil
                                    .aceitouTermoResponsabilidade ||
                                  !_vm.usuario.perfil.aceitouTermoUsoLgpd,
                                color: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.aceitarTermos()
                                },
                              },
                            },
                            [_vm._v(" Confirmar ")]
                          )
                        : _vm._e(),
                      _c(
                        VBtn,
                        {
                          attrs: { color: "primary", outlined: "" },
                          on: { click: _vm.cancelar },
                        },
                        [_vm._v(" " + _vm._s(_vm.nomeBtn()) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }